// Module
var code = "<!-- ko text: text -->\n<!-- /ko -->\n";
// Exports
module.exports = code;